export interface AnonimizeProfile {
  name: string;        // Identificador interno
  label: string;       // Label visível no UI
  default_entity_types: string[];
  allowed_entity_types: string[];
}


const API_BASE = process.env.REACT_APP_PROFILES_URL || "http://localhost:4000";

let profiles: AnonimizeProfile[] = [];


export async function loadAnonimizeProfiles(): Promise<void> {
  if (profiles.length === 0) {
    const res = await fetch(`${API_BASE}/profiles`);
    if (!res.ok) throw new Error("Erro ao carregar perfis");
    profiles = await res.json();
  }
}


export function getAnonimizeProfiles(): { name: string, label: string }[] {
    return profiles.map(({ name, label }) => ({ name, label }));
}


export function getAllProfiles(): AnonimizeProfile[] {
    return profiles;
}


export function getProfileByName(name: string): AnonimizeProfile | undefined {
    return profiles.find(p => p.name === name);
}


export async function addProfile(newProfile: AnonimizeProfile): Promise<void> {
  const exists = profiles.find(p => p.name === newProfile.name);
  if (exists) {
    throw new Error(`O perfil com o nome "${newProfile.name}" já existe.`);
  }

  const res = await fetch(`${API_BASE}/profiles`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(newProfile)
  });

  if (!res.ok) throw new Error("Erro ao adicionar perfil");

  profiles.push(await res.json());
}


export async function updateProfileByName(name: string, changes: Partial<AnonimizeProfile>): Promise<void> {
  const index = profiles.findIndex(p => p.name === name);
  if (index === -1) {
    throw new Error(`O perfil com nome "${name}" não foi encontrado.`);
  }

  const res = await fetch(`${API_BASE}/profiles/${name}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(changes)
  });

  if (!res.ok) throw new Error("Erro ao atualizar perfil");

  const updated = await res.json();
  profiles[index] = updated;
}


export async function deleteProfile(name: string): Promise<void> {
  const index = profiles.findIndex(p => p.name === name);
  if (index === -1) {
    throw new Error(`Profile with name "${name}" not found.`);
  }

  const res = await fetch(`${API_BASE}/profiles/${name}`, {
    method: "DELETE"
  });

  if (!res.ok) throw new Error("Erro ao remover perfil");

  profiles.splice(index, 1);
}


